// Translations
import accessKeyManager from 'components/model/access-key-manager/translations/ua'
import copyButton from 'components/interface/copy-button/translations/ua'
import feedback from 'components/utility/feedback/translations/ua'
import loadingError from 'components/utility/loading-error/translations/ua'
import pagination from 'components/interface/pagination/translations/ua'
import phoneNumberVerifier from 'components/model/phone-number-verifier/translations/ua'
import providerButton from 'components/external/provider-button/translations/ua'

// Translation: Ukrainian > Components
const components = Object.freeze({
	external: { providerButton },
	interface: { copyButton, pagination },
	model: { accessKeyManager, phoneNumberVerifier },
	utility: { feedback, loadingError }
})

// Export
export default components
